/**
 * This constructor creates an dynamic element countdown timer in the HTML Element
 * by replacing the pre-defined string template onto the new SPAN element,
 * containing the timer.
 * @constructor
 *
 * @param {com.inq.ui.Text} textElement - the instance of Text object defined in chat skin
 */
com.inq.ui.CountdownTimer = function(textElement) {
	this._time = 0;
	this._timerId = null;
	this._parent = textElement;
	this._element = document.createElement("span");
	this._listeners = [];
	
	this._parent.replaceTextOntoElement(com.inq.ui.CountdownTimer.TEMPLATE_MARKER, this._element);
};

com.inq.ui.CountdownTimer.prototype.show = function() {
	this._element.style.display = "";
};

com.inq.ui.CountdownTimer.prototype.hide = function() {
	this._element.style.display = "none";
};

/**
 * Checks the visibility of element.
 * This method has a limitations, but for current purpose we can use it:
 *  1) returns true even if the element positioned outside the window;
 *  2) returns true if the element has a property "visibility:hidden";
 *  3) doesn't work with <TR> elements.
 * @returns {boolean}
 */
com.inq.ui.CountdownTimer.prototype.getVisible = function() {
	return this._element.offsetHeight != 0 && this._element.offsetWidth != 0;
};

com.inq.ui.CountdownTimer.prototype.getElement = function() {
	return this._element;
};

com.inq.ui.CountdownTimer.prototype.setTime = function(endTime) {
	var now = new Date().getTime();
	var period = endTime - now;
	this.setPeriod(period);
};

com.inq.ui.CountdownTimer.prototype.setPeriod = function(period) {
	if (period > 0) {
		this._time = Math.round(period / 1000) * 1000;
	} else {
		this._time = 0;
	}
};

com.inq.ui.CountdownTimer.prototype.start = function() {
	this._timerId = setInterval(function() {
		this._time -= com.inq.ui.CountdownTimer.INTERVAL;
		if (this._time <= 0) {
			this.stop();
			this.timerEnded();
		}
		this.updateValue(this.formattedValue(this._time));
	}.bind(this), com.inq.ui.CountdownTimer.INTERVAL);
	this.updateValue(this.formattedValue(this._time), true);
};

com.inq.ui.CountdownTimer.prototype.stop = function() {
	clearInterval(this._timerId);
	this._time = 0;
};

com.inq.ui.CountdownTimer.prototype.updateValue = function(value, forceUpdate) {
	if (this.getVisible() || forceUpdate) {
		this._element.innerHTML = value;
	}
};

com.inq.ui.CountdownTimer.prototype.formattedValue = function(time) {
	time = Math.floor(time / 1000); // time to seconds
	var mm = Math.floor(time / 60);
	var ss = time % 60;
	if (ss < 10) {
		ss = "0" + ss;
	}
	return mm + ":" + ss;
};

/**
 * Adds the listener of timer ending.
 * This function will be fired when timer is ended.
 * @param {function} handler
 */
com.inq.ui.CountdownTimer.prototype.addEndingListener = function(handler) {
	if (typeof handler == "function") {
		this._listeners.push(handler);
	}
};

/**
 * Removes the specified function from listeners of timer ending.
 * @param {function} handler
 */
com.inq.ui.CountdownTimer.prototype.removeEndingListener = function(handler) {
	if (typeof handler == "function") {
		for (var i = 0; i < this._listeners.length; i++) {
			if (this._listeners[i] == handler) {
				this._listeners.splice(i, 1);
			}
		}
	}
};

/**
 * This method invokes when timer is ended and it fire the all listeners
 * which was subscribed on this event.
 */
com.inq.ui.CountdownTimer.prototype.timerEnded = function() {
	for (var i = 0; i < this._listeners.length; i++) {
		this._listeners[i]();
	}
};

/** @type {string} */
com.inq.ui.CountdownTimer.TEMPLATE_MARKER = "{{COUNTDOWN-TIMER}}";

/** @type {number} the timer step is 1 second */
com.inq.ui.CountdownTimer.INTERVAL = 1000;